module.exports = __webpack_public_path__ + "media/components/web/pages/index/resources/images/managers/emmanuel_gregory-387a45299cc7edc18fa685e1e176224f.png";